export default "__VITE_ASSET__Bio4ploP__"